// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"445368c5","252":"37b04f54","327":"79e93d7b"}[chunkId] + ".chunk.js";
};